import { Box } from "@twilio-paste/core/box";
import { InformationIcon } from "@twilio-paste/icons/esm/InformationIcon";
import {
  PopoverContainer,
  PopoverButton,
  Popover,
} from "@twilio-paste/core/popover";
import { Text } from "@twilio-paste/core/text";
import { DescriptionPopoverBlock } from "@twiliointernal/e2-commons-shared-definitions";

interface DescriptionPopoverRendererProps {
  block: DescriptionPopoverBlock;
}

const DescriptionPopoverRenderer: React.FC<DescriptionPopoverRendererProps> = ({
  block,
}) => {
  const { title, description } = block.values;

  return (
    <Box marginBottom="space20">
      <PopoverContainer baseId="table-description-popover">
        <PopoverButton variant="link">
          <InformationIcon decorative={false} title="help" />
          {title}
        </PopoverButton>
        <Popover aria-label="Popover">
          <Text as="p" whiteSpace="pre-wrap">
            {description}
          </Text>
        </Popover>
      </PopoverContainer>
    </Box>
  );
};

export default DescriptionPopoverRenderer;
